import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const saleCommissionPdf = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();
    const userName = store.state.user.user.name;

    const exportToPDF = (company, tableItems, totalValue, month) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(tableItems, totalValue, month),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Commission Payout - ' + formatYearMonth(month),
            }
        }

        pushIntoTable(doc, tableItems, totalValue)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function formatYearMonth(value) {
        if (!value) return '';
        const [year, month] = value.split('-');
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' })
            .format(new Date(year, month - 1));
    }

    const getContent = (tableItems, totalValue, month) => {
        return [
            {
                text:  'Sale Commission Payout - ' + formatYearMonth(month),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            getSummaryCardSection(totalValue),

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '5%', '11%', '11%', '9%', '10%', '10%', '11%', '11%', '11%', '11%' ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getSummaryCardSection = (totalValue) => {
        const cards = [
            { label: 'Total Sales Submission', value: commaFormat(totalValue.sale_allocation_amount) },
            { label: 'Personal Sale Commission', value: commaFormat(totalValue.personal_sale_amount) },
            { label: 'Group Sale Commission', value: commaFormat(totalValue.group_sale_commission) },
            { label: 'BP Commission', value: commaFormat(totalValue.group_bp_commission) },
            { label: 'Total Commission', value: commaFormat(totalValue.total_sale_commission) },
            { label: 'Payout Percentage', value: commaFormat(totalValue.payout_percentage) + '%' },
        ]

        const cardWidth = (100 / cards.length).toFixed(2) + '%';

        return {
            margin: [0, 10, 0, 0],
            columns: cards.map((card) => {
                return {
                    width: cardWidth,
                    stack: [{
                        table: {
                            widths: ['100%'],
                            heights: [28, 20],
                            body: [
                                [{ text: card.label, bold: true, fontSize: 8, color: 'black', margin: [4, 3, 4, 0] }],
                                [{ text: card.value, bold: true, fontSize: 11, color: 'black', alignment: 'left', margin: [4, 0, 4, 3] }]
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? 0.5 : 0;
                            },
                            vLineWidth: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? 0.5 : 0;
                            },
                            hLineColor: function () { return '#d8d6e0'; },
                            vLineColor: function () { return '#d8d6e0'; }
                        }
                    }]
                }
            }),
            columnGap: 5
        }
    }

    const pushIntoTable = (doc,tableItems, totalValue) => {
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);
        let rows = getCommissionTable(tableItems);
        doc.content[2].table.body.push(...rows);

        doc.content[2].table.body.push([
            {text: 'Total', colSpan: 4, alignment: 'left'},
            {}, {}, {},
            {text: commaFormat(totalValue.allocated_sales_amount), alignment: 'right'},
            {text: commaFormat(totalValue.personal_sale_amount), alignment: 'right'},
            {text: commaFormat(totalValue.group_sale_commission), alignment: 'right'},
            {text: commaFormat(totalValue.company_sale_share), alignment: 'right'},
            {text: commaFormat(totalValue.group_bp_commission), alignment: 'right'},
            {text: commaFormat(totalValue.total_sale_commission), alignment: 'right'},
        ]);

        doc.content[2].table.body.push([
            {text: 'Total Sales Submission', colSpan: 9, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {},
            {text: commaFormat(totalValue.sale_allocation_amount), alignment: 'right'},
        ]);

        doc.content[2].table.body.push([
            {text: 'Payout Percentage(%)', colSpan: 9, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {},
            {text: commaFormat(totalValue.payout_percentage) + '%', alignment: 'right'},
        ]);
    }

    const getCommissionTable = (tableItems) => {
        const body = [];

        tableItems.forEach(item => {
            body.push([
                {text: item.serial_no},
                {text: item.name},
                {text: `${item.level_name} (${item.equivalent_designation})`},
                {text: item.parent_serial_no},
                {text: commaFormat(item.allocated_sales_amount), alignment: 'right'},
                {text: commaFormat(item.personal_sale_amount), alignment: 'right'},
                {text: commaFormat(item.group_sale_commission), alignment: 'right'},
                {text: commaFormat(item.company_sale_share), alignment: 'right'},
                {text: commaFormat(item.group_bp_commission), alignment: 'right'},
                {text: commaFormat(item.total_sale_commission), alignment: 'right'},
            ]);
        });

        return body;
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: 'Staff ID'},
            {text: 'Staff Name'},
            {text: 'Designation'},
            {text: 'Ref ID'},
            {text: 'Sales Amount', alignment: 'right'},
            {text: 'Personal Sales Commission', alignment: 'right'},
            {text: 'Group Sales Commission', alignment: 'right'},
            {text: 'Company Sales Share', alignment: 'right'},
            {text: 'BP Commission', alignment: 'right'},
            {text: 'Total Commission', alignment: 'right'},
        ]

        return tableHeader
    }

    return {
        exportToPDF
    }
}

export default saleCommissionPdf;